import React, { CSSProperties } from 'react';
import * as styles from './index.module.less';
import { INavItem } from '@/layout/constants';
import NavTitle from '@/components/heading/NavTitle';
import { Caption } from '@/components';

interface IProps {
  data: INavItem;
  isShowDesc?: boolean;
  style?: CSSProperties;
  isSideNavBar?: boolean;
}

const NavCardItem = ({ data, isShowDesc = true, style, isSideNavBar }: IProps) => {
  const { link, title, icon, desc, hoverBg = '#F8F9FA' } = data;
  return (
    <a
      href={link}
      style={style}
      className={`${styles.nav_card_container} ${(!desc || !isShowDesc) && styles.nav_card_only_title_layout}`}
    >
      <div className={styles.card_bg} style={{ background: hoverBg }}></div>
      <div className={`${styles.card_main_container} ${(!desc || !isShowDesc) && styles.card_main_only_title_layout}`}>
        {icon && (
          <div className={styles.icon_container}>
            <img src={icon.src} alt={icon.alt} className={styles.nav_icon} />
          </div>
        )}
        <div className={styles.content_container}>
          <NavTitle style={isSideNavBar ? { fontWeight: '400' } : {}}>{title}</NavTitle>
          {isShowDesc && desc && <Caption className={styles.nav_card_desc}>{desc}</Caption>}
        </div>
      </div>
    </a>
  );
};
export default NavCardItem;
